import { render, staticRenderFns } from "./CustomerEditTabDocuments.vue?vue&type=template&id=beeb08c2&"
import script from "./CustomerEditTabDocuments.vue?vue&type=script&lang=js&"
export * from "./CustomerEditTabDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports